import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SpecificationService } from '../../services/specification.service';
import { ExcelService } from 'src/app/shared/services/excel.service';
import { Subscription } from 'rxjs';
import { SpecificationUploadComponent } from '../common/specification-upload/specification-upload.component';
import { AddEditShipmentSpecificationComponent } from './add-edit-shipment-specification/add-edit-shipment-specification.component';

@Component({
  selector: 'app-shipment-specification-list',
  templateUrl: './shipment-specification-list.component.html',
  styleUrls: ['./shipment-specification-list.component.scss'],
})
export class ShipmentSpecificationListComponent implements OnInit, OnDestroy {
  searchTerm: string = '';
  searchTermValue: string = '';
  onSpecUpdateAndCreation: boolean = false;
  showDeleteButton: boolean = false;
  specDeletionList = [];
  subscription = new Subscription();
  lineItemsArray = [
    'lineItemNumber',
    'lineItemDiscription',
    'lineItemUnitPrice',
    'lineItemUnitPriceCurrency',
    'lineItemQuantity',
    'lineItemQuantityUnitofMeasurement',
    'lineItemExportCommodityCode',
    'lineItemImportCommodityCode',
    'lineItemExportReasonType',
    'lineItemPartNumber',
    'lineItemReference',
    'lineItemManufactureCountry',
    'lineItemNetWeight',
    'lineItemGrossWeight',
  ];
  piecesArray = [
    'pieceNumber',
    'piecePackagingType',
    'piecePackagingLength',
    'piecePackageWidth',
    'piecePackageHeight',
    'piecePackageWeight',
    'pieceReference',
    'pieceId',
    'pieceContentDescription',
  ];

  constructor(
    private dialog: MatDialog,
    private specificationService: SpecificationService,
    private excelService: ExcelService
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.specificationService.specificationDeletionList.subscribe(list => {
        if (list.length) {
          this.specDeletionList = list;
          this.showDeleteButton = true;
        } else {
          this.specDeletionList = [];
          this.showDeleteButton = false;
        }
      })
    );
  }

  createSpecification() {
    const specificationDetailsCreateDialogRef = this.dialog.open(
      AddEditShipmentSpecificationComponent,
      {
        disableClose: true,
        autoFocus: false,
        maxHeight: '100vh',
        maxWidth: '90vw',
        data: {
          action: 'create',
        },
      }
    );
    this.subscription.add(
      specificationDetailsCreateDialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.specificationService.onSpecUpdateAndCreation.next(true);
        }
      })
    );
  }

  deleteSpecification() {
    this.specificationService.onSpecDeleteClick.next(true);
  }

  searchSpecification(searchTerm: string) {
    this.searchTermValue = searchTerm;
  }

  editSpecEvent(spec: any) {
    const specValue = {
      specifications_id: spec?.specId,
      file_format: spec?.fileFormat,
    };
    const specificationDetailsCreateDialogRef = this.dialog.open(
      AddEditShipmentSpecificationComponent,
      {
        disableClose: true,
        autoFocus: false,
        maxHeight: '100vh',
        maxWidth: '90vw',
        data: {
          action: 'update',
          spec: specValue,
        },
      }
    );
    this.subscription.add(
      specificationDetailsCreateDialogRef.afterClosed().subscribe(res => {
        if (res.value) {
          this.onSpecUpdateAndCreation = true;
        }
      })
    );
  }

  uploadSpecEvent(data) {
    const specificationDetailsCreateDialogRef = this.dialog.open(
      AddEditShipmentSpecificationComponent,
      {
        disableClose: true,
        autoFocus: false,
        maxHeight: '100vh',
        maxWidth: '90vw',
        data: {
          action: 'upload',
          spec: data,
        },
      }
    );
    this.subscription.add(
      specificationDetailsCreateDialogRef.afterClosed().subscribe(res => {
        if (res.value) {
          this.specificationService.onSpecUpdateAndCreation.next(true);
        }
      })
    );
  }

  openUploadSpecification() {
    const uploadDialogRef = this.dialog.open(SpecificationUploadComponent, {
      disableClose: true,
      autoFocus: false,
      maxHeight: '90vh',
      maxWidth: '90vw',
    });
    uploadDialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.specificationService.extractJSONfromFile(res, data => {
          this.uploadSpecEvent(data);
        });
      }
    });
  }

  downloadTemplateExcel(spec: any) {
    if (spec?.file_format === 'EASYSHIP' && spec?.data) {
      if (spec?.data?.includes('lineItems')) {
        this.replaceDataInSpec(spec, 'lineItems', this.lineItemsArray);
      }
      if (spec?.data?.includes('pieces')) {
        this.replaceDataInSpec(spec, 'pieces', this.piecesArray);
      }
    }
    this.excelService.exportAsExcelFileWithHeader(
      spec?.data,
      `${spec?.specifications_id}-${spec?.file_format}`
    );
  }

  replaceDataInSpec(spec, targetData, replacementArray) {
    const index = spec?.data?.indexOf(targetData);
    if (index >= 0) {
      spec.data.splice(index, 1);
      spec.data.push(...replacementArray);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
